import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DialogService } from '../dialog/dialog.service';
import { PopupFormComponent } from '../popupform/popupform.component';
@Component({
    selector: 'app-dynamic-table',
    templateUrl: './dynamic-table.component.html',
    styleUrls: ['./dynamic-table.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DynamicTableComponent),
            multi: true
        }
    ],
    standalone: false
})
export class DynamicTableComponent implements OnInit {
  @Input('value') _value = "";
  @Input() question: any = "";
  editableGridConfig: any = {};
  _currentConfig: any = {};
  propagateChange = (_: any) => { };
  onTouched: any = () => { };
  form = new FormGroup({
    gridData: new FormControl('')
  });
  constructor(public dialogservice: DialogService) { }

  ngOnInit(): void {
    this._currentConfig.deleteTable = false;
    if (this.value != undefined && this.value) {
      let val = JSON.parse(this.value);
      this._currentConfig.deleteTable = true;
      this.editableGridConfig = val.tableConfig;
      this.editableGridConfig['config']['items'] = val['tableVal'];
      this.editableGridConfig['config']['questionKey'] = this.question && this.question.key ? this.question.key : '';
      console.log("IF editableGridConfig=>", this.editableGridConfig);
    }
    //this case is for creating the predefined table
    else if (this.question.tabular_list != undefined && this.question.tabular_list) {
      this.createJson(this.question.tabular_list);
      console.log("else editableGridConfig=>", this.editableGridConfig);
    }
  }


  openConfig(res, event?, temp?) {
    let obj = {
      // data: {
      resource: res,
      layout_type: 'simple',
      getdata: true
      // }
    };
    this.dialogservice
      .open(PopupFormComponent, obj).afterClosed.subscribe(data => {
        if (data != undefined) {
          if (event != undefined && event) {
            event.object['rowheader'] = data.result.title;
            event.editableGrid[event.editableGrid.length - 1].controls.rowheader.setValue(data.result.title);
            //update question value after add rowheader in new row
            if (temp != undefined && temp.editableTable != undefined && temp.editableTable.value != undefined && temp.editableTable.value.editableRows != undefined) {
              temp.editableTable.value.editableRows[temp.editableTable.value.editableRows.length - 1].rowheader = data.result.title;
              let obj = { tableVal: temp.editableTable.value.editableRows, tableConfig: this.editableGridConfig }
              this.value = JSON.stringify(obj);
              // this.value['json'] = JSON.stringify(this.editableGridConfig);
            }
          }
          else {
            this.createJson(data.result);
          }
        }
      }, err => { });
  }

  get value(): any {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
    this.onTouched();
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      this.value = "";
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  createJson(field) {
    //this will determine do we have to make rows on the basis of row headers or on the number
    this.editableGridConfig['is_rowHeader'] = field.is_rowHeader != undefined ? field.is_rowHeader : false;
    this.setConfig(field.rowHeader != undefined ? field.rowHeader : field.no_of_rows);
    if (this.editableGridConfig['is_rowHeader']) {
      let row_header_title = "field.val.empty";
      if (field?.row_header_title != null && field.row_header_title !== '') {
        row_header_title = field.row_header_title;
      }
      this.rowHeaderMap(field.rowHeader, field.fields, row_header_title);
    }
    let exp = field.row_type != undefined && field.row_type == 'dynamic' ? "true" : "false";
    this.editableGridConfig['json'] = {
      list: {
        fields: field.fields, rowHeader: field.rowHeader
      }
    };
    if (eval(exp)) {
      this.editableGridConfig['json'].list['actions'] = eval(exp) ? [{
        conditions: [{
          "copy": field,
          "expression": exp
        },
        {
          "delete": true,
          "expression": exp
        },
        {
          "add": true,
          "expression": exp
        }]
      }] : false;
    }
  }

  setConfig(gridRows) {
    this._currentConfig.deleteTable = true;
    this.editableGridConfig['config'] = {};
    this.editableGridConfig['config']['items'] = this.getVal(gridRows);
    this.editableGridConfig['config']['search'] = false;//as search is not needed here; 
    this.editableGridConfig['config']['last_row_add'] = true;
    this.editableGridConfig['config']['questionKey'] = this.question && this.question.key ? this.question.key : '';
  }

  listen_changes(event, temp) {
    if (event.type != undefined && event.type === "new_row") {
      if (this.editableGridConfig['is_rowHeader']) {
        this.openConfig('rowHeader', event, temp);
      }
      else {
        //do nothing
      }
    }
    if (temp != undefined && temp.editableTable != undefined && temp.editableTable.value != undefined && temp.editableTable.value.editableRows != undefined) {
      let obj = { tableVal: temp.editableTable.value.editableRows, tableConfig: this.editableGridConfig }
      this.value = JSON.stringify(obj);
      // this.value['json'] = JSON.stringify(this.editableGridConfig);
    }
  }

  deleteTable() {
    this._currentConfig.deleteTable = false;
    this.editableGridConfig = {};
    this.value = "";
  }

  rowHeaderMap(rowheader, field, row_header_title) {
    field.unshift({
      "label": row_header_title,
      "name": "rowheader",
      "component": "label",
      "type": "string",
      "order": 0
    })
  }

  //this function will set default rows in editable grid
  getVal(val) {
    let arr = [];
    if (this.editableGridConfig['is_rowHeader']) {
      for (let obj of val) {
        arr.push({ rowheader: obj.title });
      }
    }
    else {
      for (let i = 0; i < val; i++) {
        arr.push({});
      }
    }
    return arr;
  }

  ngOnDestroy() {
    if (localStorage && localStorage.getItem("consumeServices") != null)
      localStorage.removeItem("consumeServices");
  }
}
